const globalLinks = {
  TermsAndConditionLink: 'https://lendistry.com/esign-docs-consent/',
  TermsAndConditionText: 'Lendistry’s Consent for Electronic Signatures and Documents',
};

export default {
  globalLinks,
};
